export class PhoneNumber {
    constructor(input: string | string[]) {
        if (typeof input === 'string') {
            const digits = input.replace(/-/g, '');
            this.areaCode = digits.substring(0, 3);
            this.prefix = digits.substring(3, 6);
            this.lineNumber = digits.substring(6, 10);
        } else {
            [this.areaCode, this.prefix, this.lineNumber] = input;
        }
    }

    public areaCode: string;

    public prefix: string;

    public lineNumber: string;

    public get digits() {
        return `${this.areaCode}${this.prefix}${this.lineNumber}`;
    }

    public get isNotBlank() {
        return this.toString().length > 0;
    }

    public withAreaCode(areaCode: string) {
        return new PhoneNumber([areaCode, this.prefix, this.lineNumber]);
    }

    public withPrefix(prefix: string) {
        return new PhoneNumber([this.areaCode, prefix, this.lineNumber]);
    }

    public withLineNumber(lineNumber: string) {
        return new PhoneNumber([this.areaCode, this.prefix, lineNumber]);
    }

    public get isValid() {
        return /\d{10}/.test(this.digits);
    }

    public toString() {
        if (this.digits.length === 10) {
            return `${this.areaCode}-${this.prefix}-${this.lineNumber}`;
        }
        return this.digits;
    }

    public copy() {
        return new PhoneNumber([this.areaCode, this.prefix, this.lineNumber]);
    }
}
